import { useScroll, useSpring, useTransform } from 'motion/react';
import { useRef } from 'react';
function createRefAndScrollYProgress() {
    const ref = useRef(null);
    const scroll = useScroll({
        target: ref,
        offset: ['start end', 'end start'],
    });
    const scrollYProgress = useSpring(scroll.scrollYProgress, {
        stiffness: 100,
        damping: 25,
        restDelta: 0.001,
    });
    return { ref, scrollYProgress };
}
export function useAnimation() {
    const { ref: imageContainerRef, scrollYProgress: imageContainerScrollYProgress } = createRefAndScrollYProgress();
    const { ref: titlePartOneRef, scrollYProgress: titlePartOneScrollYProgress } = createRefAndScrollYProgress();
    const { ref: titlePartTwoRef, scrollYProgress: titlePartTwoScrollYProgress } = createRefAndScrollYProgress();
    const { ref: textRef, scrollYProgress: textScrollYProgress } = createRefAndScrollYProgress();
    const titlePartOne = {
        opacity: useTransform(titlePartOneScrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]),
    };
    const titlePartTwo = {
        opacity: useTransform(titlePartTwoScrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]),
    };
    const text = {
        opacity: useTransform(textScrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]),
    };
    const imageContainer = {
        top: useTransform(imageContainerScrollYProgress, [0, 0.425, 0.575, 1], ['100%', '50%', '50%', '0%']),
    };
    const featuredImage = {
        scale: useTransform(imageContainerScrollYProgress, [0, 0.425, 0.575, 1], [0.8, 1, 1, 0.8]),
        rotate: useTransform(imageContainerScrollYProgress, [0, 0.425, 0.575, 1], ['0deg', '-11deg', '-11deg', '0deg']),
    };
    const image = {
        scale: 0.8,
    };
    return {
        titlePartOne,
        titlePartOneRef,
        titlePartTwo,
        titlePartTwoRef,
        text,
        textRef,
        imageContainerRef,
        imageContainer,
        featuredImage,
        image,
    };
}
